import { ApiProperty } from '@nestjs/swagger';
import { IsEmail, IsNotEmpty, IsOptional, ValidateIf } from 'class-validator';
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Customers } from '../customers/customers.entity';

@Entity('payment_mode')
export class PaymentMode {
  
  @PrimaryGeneratedColumn("increment",{name:'payment_mode_id'})
  paymentModeId:number;
  @Column("varchar",{
    nullable: true,
    length:15,
    name:"payment_mode"
    })
  // @Index({unique:true})
  paymentMode:string;

  @Column("boolean",{
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;
  
  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  // @OneToMany(type=>Customers, customers=>customers.paymentModeId,{cascade: true})
  // customerInfo:Customers[];

  // @OneToMany(type=>PaymentMode, PaymentMode=>PaymentMode.paymentModeId,{cascade: true})
  // PaymentModeInfo:PaymentMode[];
  }
